<template>
  <div class="">
    <ClassicButton
      classButton="rounded-full"
      type="button"
      flexOption=""
      @buttonClick.prevent="
        showModal = !showModal;
        pickedColor = selectedColor;
      "
    >
      <template v-slot:ButtonContent>
        <ColorRound
          :color="'text-' + selectedColor + '-600'"
          size="size-10"
        />
      </template>
    </ClassicButton>

    <Modal
      :enableEsc="false"
      :fixOverflow="false"
      :showModal="showModal"
      @modaleOpen="showModal = $event"
      :selectedColor="selectedColor"
      :pickedColor="selectedColor"
      :pickerTitle="pickerTitle"
    >
      <template v-slot:modalHeader>
        <button
          @click.prevent="
            showModal = !showModal;
            pickedColor = selectedColor;
          "
          type="button"
          :class="'modal-header  color-' +  pickedColor"
        >
          Fermer
        </button>
      </template>
      <template v-slot:modalBody>
        <div :class="'modal-body color- ' + pickedColor + ' container '">
          <div class="flex">
            <button
              type="button"
              class="modal-close"
              @click.prevent="showModal = false"
            >
              &times;
            </button>
          </div>
          <h2 class="modal-title">
            {{ pickerTitle }}, quelle couleur pour toi ?
          </h2>
          <div class="my-8">
            <ColorPicker
              @selectColor="
                pickedColor = $event;
                showModal = false;
                selectedColor = pickedColor;
                $emit('selectedColor', selectedColor);
              "
              :selectedColor="selectedColor"
              :pickedColor="pickedColor"
            />
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/ui/generic/Modal.vue";
import ClassicButton from "@/components/ui/form/button/ClassicButton.vue";
import ColorRound from "@/components/ui/generic/fragments/ColorRound.vue";
import ColorPicker from "@/components/ui/generic/ColorPicker.vue";

export default {
  name: "colorpicker",
  props: {
    initialColor: {
      type: String,
      required: false,
      default: "gray"
    },
    pickerTitle: {
      type: String,
      required: true,
      default: "Choix de couleur"
    }
  },
  data() {
    return {
      showModal: false,
      selectedColor: this.initialColor,
      pickedColor: "gray",
      title: this.pickerTitle
    };
  },
  components: {
    Modal,
    ColorRound,
    ColorPicker,
    ClassicButton
  }
};
</script>
